<div class="modal-content mx-4">
  <!-- <app-alert [message]="alertMessage" [show]="showAlert" [showCancel]="showCancel" [showConfirm]="showConfirm"
    (closed)="showAlert = false" (confirmed)="onAlertClosed(true)">
  </app-alert> -->
  <div class="modal-body">
    <div>
      <mat-card-title class="text-dark">Cadastro do Ambiente</mat-card-title>
      <div class="b-t-1 row">
        <div class="col-sm-6 m-t-24">
          <form [formGroup]="environmentForm">
            <mat-label class="f-w-600 m-b-8 d-block">Nome</mat-label>
            <mat-form-field appearance="outline" class="w-100" color="primary">
              <input matInput formControlName="name" />
              <mat-error
                *ngIf="environmentForm.get('name')?.hasError('required')"
              >
                Nome é obrigatório
              </mat-error>
            </mat-form-field>

            <mat-label class="f-w-600 m-b-8 d-block m-t-16">Unidade</mat-label>
            <mat-form-field appearance="outline" class="w-100" color="primary">
              <mat-select formControlName="unity">
                @for (unity of business_units; track unity.uuid) {
                  <mat-option [value]="unity.uuid">
                    {{ unity.name }}
                  </mat-option>
                }
              </mat-select>
              @if (environmentForm.get('unity')?.hasError('required')) {
                <mat-error> Unidade é obrigatória </mat-error>
              }
            </mat-form-field>

            <mat-label class="f-w-600 m-b-8 d-block m-t-16"
              >Descrição</mat-label
            >
            <mat-form-field appearance="outline" class="w-100" color="primary">
              <textarea matInput rows="2" formControlName="details"></textarea>
              <mat-error
                *ngIf="environmentForm.get('details')?.hasError('required')"
              >
                Descrição é obrigatória
              </mat-error>
            </mat-form-field>
          </form>
        </div>
        <div
          class="col-sm-6 m-t-24 d-flex"
          style="
            flex-direction: column;
            justify-content: center;
            align-items: center;
          "
        >
          <mat-label class="f-w-600 d-block m-b-8">
            Imagens do Ambiente
          </mat-label>
          <app-carousel
            [entity]="{ uuid: environment.uuid, name: 'environment' }"
          ></app-carousel>
        </div>
      </div>
    </div>

    <div class="text-right m-t-24">
      <button mat-stroked-button color="warn" class="m-r-8" (click)="close()">
        Cancelar
      </button>

      <button
        mat-flat-button
        color="accent"
        class="cardWithShadow"
        (click)="isEditing ? update() : create()"
        class="cardWithShadow"
        [disabled]="!environmentForm.valid"
      >
        Salvar
      </button>
    </div>
  </div>
</div>
